import type {
  BaseUserRole,
  Onboarding,
  PermissionSet,
  Shop,
  SubscriptionInfo,
  SubscriptionInfoFeaturesItem,
  TechnicianInfo,
  UserRole,
  UserRoleRole,
} from '@/shared/api';
import type { CurrentUserInterface, OrgRole, PermissionString } from './types';
import { EMPTY_PERMISSIONS } from './constants';

export class AnonymousUser implements CurrentUserInterface {
  shop: Shop | null = null;
  readonly isDemo: boolean = false;
  systemRole: UserRoleRole | null = null;
  shopRoles: UserRole[] = [];
  isAdmin: boolean = false;
  isTechnician: boolean = false;
  isOrgOwner: boolean = false;
  isOrgAdmin: boolean = false;
  displayName: string = '';
  initials: string = '';
  roleNameKey: string = '';
  id: string = '';
  avatarUrl: string | null = null;
  firstName: string = '';
  lastName: string = '';
  email: string = '';
  phone: string = '';
  role: BaseUserRole = 'technician';
  currentShopId: string | null = null;
  emailVerified: boolean = false;
  onboarding: Onboarding = { isCompleted: false, isDismissed: false };
  technician: TechnicianInfo = { isActive: false, color: null };
  roles: UserRole[] = [];
  shops: Shop[] = [];
  permissions: PermissionSet = EMPTY_PERMISSIONS;
  subscription: SubscriptionInfo = {
    tier: 'free',
    features: ['basic_invoicing', 'customer_management'],
    expiresAt: null,
    stripeCustomerId: null,
    interval: null,
    freeRosAllowance: 3,
    freeRosUsed: 0,
    freeRosRemaining: 3,
    freeRosUnlimited: false,
    paymentMethodOnFile: false,
    cancelAtPeriodEnd: false,
  };
  stripePublishableKey: string = '';
  orgRole: OrgRole = null;
  organizationId: string | null = null;
  setupAnnouncementShowUntil: string | null = null;
  setupPanelDismissedAt: string | null = null;

  /**
   * Anonymous users have no permissions
   */
  can(_permission: PermissionString): boolean {
    return false;
  }

  /**
   * Anonymous users have no subscription features
   */
  hasFeature(_feature: SubscriptionInfoFeaturesItem): boolean {
    return false;
  }
}
